
export enum Role {
  Admin = "admin",
  CommitteeMember = "committeeMember",
  DepartmentHead = "departmentHead",
  Viewer = "viewer",
  Lecturer = "lecturer",
}
